import { createFeature, createReducer, on } from '@ngrx/store';
import { AgentReportModel } from '@shared/data-access/models';
import { ReportAction } from '../actions';

export const featureName = 'agentReport';

export interface ReportState {
  item: AgentReportModel | null;
}
export const initialState: ReportState = {
  item: null,
};
export const reportFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(ReportAction.loadItemSuccess, (state, prop: { item: AgentReportModel }) => ({ ...state, item: prop.item }))
  ),
});

export const {
  name, // feature name
  reducer, // feature reducer
} = reportFeature;
